import "@emotion/react";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { COLOR_ATHENS_GRAY, COLOR_STALE_GRAY } from "./styles";

type IMUITheme = typeof MUITheme;

declare module "@emotion/react" {
  export interface Theme extends IMUITheme {}
}

const themeConfig = createTheme({
  typography: {
    fontFamily: "SF Pro Text",
    h1: {
      fontFamily: `SF Pro Display`,
    },
    h2: {
      fontFamily: `SF Pro Display`,
    },
    h3: {
      fontFamily: `SF Pro Display`,
    },
    h4: {
      fontFamily: `SF Pro Display`,
    },
    h5: {
      fontFamily: `SF Pro Display`,
    },
    h6: {
      fontFamily: `SF Pro Display`,
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: "none",
      },
    },
    MuiListItemButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
          body,
          html {
            height: 100%;
          }
          
          body {
            font-size: 14px;
            background-color: ${COLOR_ATHENS_GRAY};
          }

          label {
            font-size: 12px;
            font-weight: 600;
            color: ${COLOR_STALE_GRAY};
            margin-bottom: 4px;
          }

          @font-face {
            font-family: SF Pro Display;
            src: url("/static/fonts/SFPRODISPLAYREGULAR.OTF") format("opentype");
            font-weight: 400;
          }

          @font-face {
            font-family: SF Pro Display;
            src: url("/static/fonts/SFPRODISPLAYBOLD.OTF") format("opentype");
            font-weight: 700;
          }

          @font-face {
            font-family: SF Pro Display;
            src: url("/static/fonts/SFPRODISPLAYMEDIUM.OTF") format("opentype");
            font-weight: 500;
          }

          @font-face {
            font-family: SF Pro Text;
            src: url("/static/fonts/SF-Pro-Text-Medium.otf") format("opentype");
            font-weight: 500;
          }
          @font-face {
            font-family: SF Pro Text;
            src: url("/static/fonts/SF-Pro-Text-Regular.otf") format("opentype");
            font-weight: 400;
          }
          @font-face {
            font-family: SF Pro Text;
            src: url("/static/fonts/SF-Pro-Text-Bold.otf") format("opentype");
            font-weight: 700;
          }
        `,
    },
  },
});

export const MUITheme = responsiveFontSizes(themeConfig);
